import React, { useState } from "react";
import "../../components/AddPetCrate/AddPetCrate.css";
import axios from "axios";

const AddPetCrate = ({ tokenStorage, openAddProfile, setOpenAddProfile, successMessage, setSuccessMessage }) => {

  const baseAPI = process.env.REACT_APP_API_URL;

  const [formData, setFormData] = useState({
    Crate_Type: "",
    Amount: "",
    Lengths: "",
    Width: "",
    Height: "",
    Is_Active: "true",
  });

  const handleChange = (e) => {
    const { name, value } = e.target;

    // Restrict non-numeric input for Amount, Lengths, Width, and Height fields
    if (["Amount", "Lengths", "Width", "Height"].includes(name)) {
      if (!isNaN(value) || value === "") {
        setFormData({
          ...formData,
          [name]: value,
        });
      } else {
        alert(`${name} should be a numeric value`);
      }
    } else {
      setFormData({
        ...formData,
        [name]: value,
      });
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    // Validation: Check if any field is empty
    if (
      !formData.Crate_Type ||
      !formData.Amount ||
      !formData.Lengths ||
      !formData.Width ||
      !formData.Height ||
      !formData.Is_Active
    ) {
      alert("Please fill in all fields before submitting.");
      return;
    }

    // Validation: Check if Amount, Lengths, Width, and Height are numeric
    if (
      isNaN(formData.Amount) ||
      isNaN(formData.Lengths) ||
      isNaN(formData.Width) ||
      isNaN(formData.Height)
    ) {
      alert("Length, Width, Height, and Price should all be numeric values.");
      return;
    }

    try {
      const storedToken = JSON.parse(localStorage.getItem("token"));
      const response = await axios.post(
        `${baseAPI}adminpost/AddOrUpdatePetCrate`,
        formData,
        {
          headers: {
            Authorization: `Bearer ${storedToken}`,
          },
        }
      );
      setSuccessMessage("Data successfully submitted");

      // Reset the form
      setFormData({
        Crate_Type: "",
        Amount: "",
        Lengths: "",
        Width: "",
        Height: "",
        Is_Active: "true",
      });

      tokenStorage();
      setOpenAddProfile(!openAddProfile);
    } catch (error) {
      console.error("Error posting data:", error);
    }
  };

  return (
    <div className="container-fluid">
      <br />

      <div className="petCrateDetail">
        <form className="petCrate-form">
          <table style={{ width: "100%" }}>
            <tr className="space">
              <td colSpan={3}></td>
            </tr>
            <tr className="tableHeading">
              <td>Product Name</td>
              <td>Price</td>
              <td>Status</td>
            </tr>

            <tr>
              <td>
                <input
                  type="text"
                  name="Crate_Type"
                  value={formData.Crate_Type}
                  placeholder="Please Enter*"
                  onChange={handleChange}
                  required
                  style={{
                    fontFamily: "'Montserrat', sans-serif",
                    fontSize: "14px",
                    padding: "10px 10px 10px 25px", 
                    border: "1px solid #ccc",
                    borderRadius: "5px",
                    width: "15rem",
                  }}
                />
              </td>



              <td style={{ position: "relative" }}>
  <span
    style={{
      position: "absolute",
      left: "10px",
      top: "50%",
      transform: "translateY(-50%)",
      fontFamily: "'Montserrat', sans-serif",
      fontSize: "14px",
    }}
  >
    ₹
  </span>
  <input
    name="Amount"
    value={formData.Amount}
    placeholder="Enter Please*"
    onChange={handleChange}
    style={{
      fontFamily: "'Montserrat', sans-serif",
      fontSize: "14px",
      padding: "10px 10px 10px 25px", 
      border: "1px solid #ccc",
      borderRadius: "5px",
      width: "15rem",
    }}
  />
</td>

           







              
              <td style={{ color: "#28A745" }}>
                <select
                  name="Is_Active"
                  value={formData.Is_Active}
                  onChange={handleChange}
                  required
                  style={{
                    fontFamily: "'Montserrat', sans-serif",
                    fontSize: "14px",
                    padding: "10px 10px 10px 25px", 
                    border: "1px solid #ccc",
                    borderRadius: "5px",
                    width: "15rem",
                  }}
                >
                  <option
                    className="dropdown-employee"
                    style={{ color: "grey" }}
                    value=""
                  >
                    Please Select*
                  </option>
                  <option value="true">Active</option>
                  <option value="false">Inactive</option>
                </select>
              </td>
            </tr>
            <tr className="space">
              <td colSpan={3}></td>
            </tr>
            <tr className="tableHeading">
              <td>Length</td>
              <td>Width</td>
              <td>Height</td>
            </tr>

            <tr>
              <td>
                <input
                  type="text"
                  name="Lengths"
                  value={formData.Lengths}
                  placeholder="Please Enter value in Inches*"
                  onChange={handleChange}
                  required
                  style={{
                    fontFamily: "'Montserrat', sans-serif",
                    fontSize: "14px",
                    padding: "10px 10px 10px 25px", 
                    border: "1px solid #ccc",
                    borderRadius: "5px",
                    width: "15rem",
                  }}
                />
              </td>
              <td>
                <input
                  type="text"
                  name="Width"
                  value={formData.Width}
                  placeholder="Please Enter value in Inches*"
                  onChange={handleChange}
                  required
                  style={{
                    fontFamily: "'Montserrat', sans-serif",
                    fontSize: "14px",
                    padding: "10px 10px 10px 25px", 
                    border: "1px solid #ccc",
                    borderRadius: "5px",
                    width: "15rem",
                  }}
                />
              </td>
              <td>
                <input
                  type="text"
                  name="Height"
                  value={formData.Height}
                  placeholder="Please Enter value in Inches*"
                  onChange={handleChange}
                  required
                  style={{
                    fontFamily: "'Montserrat', sans-serif",
                    fontSize: "14px",
                    padding: "10px 10px 10px 25px", 
                    border: "1px solid #ccc",
                    borderRadius: "5px",
                    width: "15rem",
                  }}
                />
              </td>
            </tr>
            <tr className="space">
              <td colSpan={3}></td>
            </tr>
          </table>
          <br />
          <hr />
          <div className="reset-addPetCrate-button">
            <button style={{ backgroundColor: "#F15843", color: "white" }}>
              Reset
            </button>
            <button
              type="submit"
              onClick={handleSubmit}
              style={{
                marginRight: "10px",
                backgroundColor: "#5B489D",
                color: "white",
              }}
            >
              Save
            </button>
          </div>
        </form>
      </div>
      <br />
    </div>
  );
};

export default AddPetCrate;

